import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import { setDefaultVariants } from './slice';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useProductsActions = () => {
  const dispatch = useAppDispatch();
  const SetDefaultVariantsAction = () => dispatch(setDefaultVariants());

  return { SetDefaultVariantsAction };
};
